// extracted by mini-css-extract-plugin
export default {"container":"complete-profile_container__FZ_7D","normal":"complete-profile_normal__37ZQK"};